export default __webpack_public_path__ + "static/media/poppy-stack4.webp";